module.exports = __webpack_public_path__ + "img/7af6bbc.jpg";